import Component from '@glimmer/component';
import { alias } from '@ember/object/computed';
import { inject as service } from '@ember/service';

export default class AppPageSettings extends Component {
  @service router;

  @alias('args.model.appPage.page') page;
}